import React from 'react';
import universal from 'react-universal-component';

// small function that allows page to be a string or a dynamic import function
// <UniversalComponent page={()=>{import('../../someFolder/Component.js')}}
// Its great for complex folder structures. You can leverage code completion
const determineHowToLoad = ({ page }) => (typeof page !== 'string' ? () => page() : import(`./${page}`));

const UniversalComponent = universal(determineHowToLoad, {
	onError: () => {
		// code has probably been updated and site needs to reload to get new mappings
		// window.location = window.location.href;
	},
});

const loadComponent = (file) => universal(determineHowToLoad({ page: file }));
export default UniversalComponent;
export { loadComponent, universal };
